import { toQueryParamsString } from '../../utils/ApiUtils';

import { API_BASE_URL } from '../../env';
import { CreateTicketOptions } from '../../interfaces/api/Ticket';
import { ApiReturnType } from '../../interfaces/api/api';
import {
  CreateAppointmentOptions,
  CreateNoteOptions,
  CreateReminderOptions,
  CreateTaskOptions,
  LegacyAppointment,
  LegacyNote,
  LegacyReminder,
  LegacyTask,
} from '../../interfaces/api/Collaborative';

export default {
  getTicketState: (id: number): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/ticket/tickets-states/${id}`,
    headers: { 'Content-Type': 'application/json' },
    method: 'GET',
  }),
  getTicketStates: (): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/ticket/tickets-states`,
    headers: { 'Content-Type': 'application/json' },
    method: 'GET',
  }),
  getClosedReasons: (): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/ticket/closed-reasons`,
    headers: { 'Content-Type': 'application/json' },
    method: 'GET',
  }),
  addAppointment: (ticketId: string, options: CreateAppointmentOptions): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/ticket/tickets/${ticketId}/appointments`,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(options),
    method: 'POST',
  }),
  removeAppointment: (ticketId: string, appointmentId: LegacyAppointment['id']): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/ticket/tickets/${ticketId}/appointments/${appointmentId}`,
    headers: { 'Content-Type': 'application/json' },
    method: 'DELETE',
  }),
  addNote: (ticketId: string, options: CreateNoteOptions): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/ticket/tickets/${ticketId}/notes`,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(options),
    method: 'POST',
  }),
  removeNote: (ticketId: string, noteId: LegacyNote['id']): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/ticket/tickets/${ticketId}/notes/${noteId}`,
    headers: { 'Content-Type': 'application/json' },
    method: 'DELETE',
  }),
  addReminder: (ticketId: string, options: CreateReminderOptions): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/ticket/tickets/${ticketId}/reminders`,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(options),
    method: 'POST',
  }),
  removeReminder: (ticketId: string, reminderId: LegacyReminder['id']): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/ticket/tickets/${ticketId}/reminders/${reminderId}`,
    headers: { 'Content-Type': 'application/json' },
    method: 'DELETE',
  }),
  addTask: (ticketId: string, options: CreateTaskOptions): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/ticket/tickets/${ticketId}/tasks`,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(options),
    method: 'POST',
  }),
  removeTask: (ticketId: string, taskId: LegacyTask['id']): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/ticket/tickets/${ticketId}/tasks/${taskId}`,
    headers: { 'Content-Type': 'application/json' },
    method: 'DELETE',
  }),
  get: (id: string): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/ticket/tickets/${id}`,
    headers: { 'Content-Type': 'application/json' },
    method: 'GET',
  }),
  getAll: (siteId?: string): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/ticket/tickets${toQueryParamsString({ siteId })}`,
    headers: { 'Content-Type': 'application/json' },
    method: 'GET',
  }),
  search: (criteria: Object, page: number, limit?: number, orderBy?: string, order?: string): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/ticket/tickets${toQueryParamsString({ ...criteria, page, limit, orderBy, order })}`,
    headers: { 'Content-Type': 'application/json' },
    method: 'GET',
  }),
  getInterventionOrderToken: (ticketId: string, providerId: string): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/ticket/tickets/${ticketId}/generate-intervention-order-token${toQueryParamsString({
      providerId,
    })}`,
    headers: { 'Content-Type': 'application/json' },
    method: 'GET',
  }),
  open: (id: string): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/ticket/tickets/${id}/open`,
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
  }),
  close: (id: string, ticketClosedReasonId: number, comment?: string): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/ticket/tickets/${id}/close`,
    body: JSON.stringify({ comment, ticketClosedReasonId }),
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
  }),
  dunning: (id: string, comment?: string): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/ticket/tickets/${id}/dunning`,
    body: JSON.stringify({ comment }),
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
  }),
  update: (id: string, values: { [fieldName: string]: any }): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/ticket/tickets/${id}`,
    body: JSON.stringify(values),
    headers: { 'Content-Type': 'application/json' },
    method: 'PATCH',
  }),
  create: (ticketOptions: CreateTicketOptions): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/ticket/tickets`,
    body: JSON.stringify(ticketOptions),
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
  }),
};
